import Button, {ButtonProps} from '@mui/material/Button';
import {styled} from '@mui/material/styles';

export const CButton = styled(Button)<ButtonProps>(
  (/* { theme } */) => ({
    borderRadius: 32
  }),
);
